import { render, staticRenderFns } from "./MailingModal.vue?vue&type=template&id=763d1a80"
import script from "./MailingModal.vue?vue&type=script&lang=js"
export * from "./MailingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports